const strict = true;

const state = {
  emailAddress: "ufficiorete@fondoest.it"
};

const getters = {
  getEmailAddress: state => state.emailAddress
};

const mutations = {
  RESET(state) {
    state.emailAddress = "ufficiorete@fondoest.it";
  }
};

const actions = {};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
